/**
 * Fires a `retailer_click` event to GA4 and Meta Pixel whenever a visitor
 * clicks any outbound retailer link (every element rendered by
 * snippets/buy-on-amazon.liquid carries [data-retailer]). Spec §2.6 —
 * this is the entire measurement layer of the affiliate business, so it
 * has to fire on every click, not just the ones a developer remembers to wire up.
 */
(function () {
  function getPageType() {
    var main = document.querySelector('main[data-template]');
    return main ? main.dataset.template : '';
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('[data-retailer]');
      if (!link) return;

      var payload = {
        product_handle: link.dataset.product || '',
        product_title: link.dataset.productTitle || '',
        retailer_name: link.dataset.retailer || '',
        region: link.dataset.region || '',
        page_type: getPageType(),
        position: link.dataset.position || '',
      };

      if (typeof window.gtag === 'function') {
        window.gtag('event', 'retailer_click', payload);
      }

      if (typeof window.fbq === 'function') {
        window.fbq('trackCustom', 'RetailerClick', payload);
      }
    },
    { passive: true }
  );
})();
